import { render, staticRenderFns } from "./performanceAttributionComponent.vue?vue&type=template&id=0766940b&scoped=true&"
import script from "./performanceAttributionComponent.vue?vue&type=script&lang=js&"
export * from "./performanceAttributionComponent.vue?vue&type=script&lang=js&"
import style0 from "./performanceAttributionComponent.vue?vue&type=style&index=0&id=0766940b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0766940b",
  null
  
)

export default component.exports